<template>
  <div>
    <v-container>
      <v-textarea
        class="mt-2 mb-n7"
        filled
        v-model="powerCodeExplainerRes"
        no-resize
        height="400"
        counter
        hide-details="auto"
        color="black"
      ></v-textarea>
    </v-container>
    <v-container class="d-flex mt-6 justify-end">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="black darken-1" v-bind="attrs" v-on="on" class="mx-1 mt-n2" icon @click="handleCopy">
            <v-icon>mdi-content-copy</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("message.PowerCodeExplainer_Copy") }}</span>
      </v-tooltip>
    </v-container>
  </div>
</template>

<script>
import {marked} from 'marked';
import DOMPurify from 'dompurify';
export default {
  name: 'PowerCodeExplainerRight',
  data() {
    return {
      powerCodeExplainerRes: '',
    }
  },
  computed: {
  },
  created() {
    this.$store.watch(
      (state) => state.powerCodeExplainerMsg.powerCodeExplainerRes, () => {
        this.powerCodeExplainerRes = this.$store.getters.getpowerCodeExplainerRes;
      }, {
        deep: true
      }
    );
    this.powerCodeExplainerRes = this.$store.getters.getpowerCodeExplainerRes;
  },
  mounted() {

  },

  methods: {
    htmlfy(answer) {
      // console.log(DOMPurify.sanitize(marked.parse(answer)))
      return DOMPurify.sanitize(marked.parse(answer));      
    },
    handleCopy() {
      const anwser=this.htmlfy(this.powerCodeExplainerRes)
      const temp = document.createElement('div');
      temp.innerHTML = anwser;
      document.body.appendChild(temp);
      const range = document.createRange();
      range.selectNode(temp);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();
      document.body.removeChild(temp);
      this.$store.commit('HandlePromptBoomSnackBar', 'Copied')
    }
  }

};
</script>

<style scoped>
</style>